import React, { memo } from 'react';
import ReactDOM from 'react-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Close from '@/assets/icons/close.svg';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { AppState } from '../../store/store';
import { toggleSlider } from '@/store/reducers/slider';
import Image from 'next/image';

const ImageSlider: React.FC = () => {
  const { isSliderOpen, imagePaths } = useSelector(
    (state: AppState) => state.slider,
    shallowEqual
  );
  const dispatch = useDispatch();

  const settings = {
    customPaging: function (i: number) {
      return (
        <div>
          <Image src={imagePaths[i]} width={36} height={36} alt='sub_image' />
        </div>
      );
    },
    dots: true,
    dotsClass: 'slick-dots slick-thumb',
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  if (isSliderOpen) {
    return ReactDOM.createPortal(
      <div id='overlay' className={isSliderOpen ? 'openSlider' : null}>
        <div
          onClick={() => dispatch(toggleSlider(false))}
          role='presentation'
          className='fixed top-10 left-16 bg-white rounded-full flex items-center justify-center p-2 hover:opacity-70 z-50'
        >
          <Image src={Close} alt='close' width={24} height={24} />
        </div>
        <div className='w-4/5 h-144 mt-6'>
          <Slider {...settings}>
            {imagePaths.map((path, key) => (
              <div
                key={key}
                className='w-[800px] h-[450px] relative flex items-center'
              >
                <Image
                  src={path}
                  alt='gallery_img'
                  layout='fill'
                  objectFit='contain'
                />
              </div>
            ))}
          </Slider>
        </div>
      </div>,
      document.getElementById('__next')
    );
  }

  return null;
};

export default memo(ImageSlider);
